import styled from 'styled-components';

import { baseText } from '../../assets/styles/text';
import {
	textAlign, fontSize, fontWeight, mobileOptions, padding, textColors, minWidth, maxWidth,
} from '../../assets/styles/props';

export const Paragraph = styled.p`
	${baseText};
	${textAlign};
	${padding};
	${textColors};
	${fontWeight};
	${mobileOptions};
	${fontSize};
	${minWidth};
	${maxWidth};
	width: 100%;
`;
